import { Component } from '@angular/core';
import { OnInit } from '@angular/core';
import { UserService } from '../../services/user.service';
import { AlertsService } from '../../services/alerts.service';
import cloneDeep from 'lodash/cloneDeep';

/**
 * Component for managing a user's UI display options.
 */
@Component({
	selector: 'user-display-opts',
	templateUrl: './display-opts.component.html',
	styleUrl: './display-opts.component.css'
})
export class DisplayOptsComponent implements OnInit {

	LOCALIZATION: any;

	searchPrefs: any[] = [];
	displayPrefs = [
		'IS_HIGHLIGHT_PDF',
		'IS_HIGHLIGHT_VIEW_FIELD',
		'PDF_DOCUMENT_DISPLAY_STYLE',
		'THEME',
		'DISPLAY_ADDITIONAL_ICONS'
	];

	constructor(
		private alertsService: AlertsService,
		private userService: UserService
	) { }

	ngOnInit(): void {
		this.LOCALIZATION = this.userService.LOCALIZATION;
		this.loadSearchOpts();
	}

	private loadSearchOpts(): void {
		let prefs = cloneDeep(this.userService.user.properties.awpropertyObjectList);
		this.searchPrefs = prefs.sort((a: any, b: any) => a.displayName.localeCompare(b.displayName));

		for (let i = 0; i < this.searchPrefs.length; i++) {
			if (this.searchPrefs[i].name == this.displayPrefs[0] || this.searchPrefs[i].name == this.displayPrefs[1]) {
				let currentValues = [];
				if (this.searchPrefs[i].value && this.searchPrefs[i].value.length > 0) {
					currentValues = this.searchPrefs[i].value.split(" ");
				}
				if (this.searchPrefs[i].optionElementList.length == 0) {
					this.searchPrefs[i].optionElementList = [
						{
							"name": "Apply Highlights",
							"value": "yes",
							"parentMask": null,
							"childs": null
						},
						{
							"name": "No Highlights",
							"value": "no",
							"parentMask": null,
							"childs": null
						}
					];
				}
				for (let j = 0; j < this.searchPrefs[i].optionElementList.length; j++) {
					let selected = false;
					if (currentValues.includes(this.searchPrefs[i].optionElementList[j].value)) {
						selected = true;
					}
				}
			}
			if (this.searchPrefs[i].name == this.displayPrefs[4]) {
				this.searchPrefs[i].value = (this.searchPrefs[i].value && this.searchPrefs[i].value.toLowerCase() === 'true') || false;
			}
		}
	}

	updatePreferences(): void {
		let prefs = {
			awpropertyObjectList: this.userService.user.properties.awpropertyObjectList,
			awsortObjectList: this.userService.user.properties.awsortObjectList,
			awfieldObjectList: this.userService.user.properties.awfieldObjectList,
			awfieldCollectionObjectList: this.userService.user.properties.awfieldCollectionObjectList,
			awlibraryObjectList: this.userService.user.properties.awlibraryObjectList
		};

		for (let i = 0; i < this.displayPrefs.length; i++) {
			let property = this.displayPrefs[i];
			let value = '';
			for (let j = 0; j < this.searchPrefs.length; j++) {
				if (this.searchPrefs[j].name == property) {
					for (let k = 0; k < prefs.awpropertyObjectList.length; k++) {
						if (prefs.awpropertyObjectList[k].name == property) {
							prefs.awpropertyObjectList[k].value = this.searchPrefs[j].value;
							break;
						}
					}
					break;
				}
			}
		}

		let cleanedPrefs = this.userService.cleanData(prefs);

		let payload = {
			prefs: JSON.stringify(cleanedPrefs)
		};

		this.userService.updateUser(payload).then(
			(response: any) => {
				this.alertsService.success({
					message: this.LOCALIZATION.userProfileUpdateSuccess,
					delay: 5000
				});
			},
			(err: any) => {
				console.error("Failed to update user details.", err);
				this.alertsService.error({
					message: this.LOCALIZATION.userProfileUpdateError,
					delay: 5000
				});
			}
		);
	}
}
